import { Injectable, inject } from '@angular/core';
import { AuthService } from '@sbe-spinoff-schoolbell-e/web-shared';
import { ApiService } from './api.service';
import { environment } from '../../environments/environment';

// schoolbell-e-web의 logout.service.ts와 달리 org-context/legacy-handoff는 이 앱에 없다 —
// 로그아웃 후에는 로그인 화면이 있는 schoolbell-e-web으로 보낸다(이 앱엔 /login이 없다).
//
// schoolbell-e-web은 router.navigate(SPA 네비게이션)라 페이지가 언로드되지 않아 진행 중인
// logout API 요청이 그대로 완료되지만, 여기는 다른 앱(schoolbell-e-web)으로 넘어가는
// window.location.href(풀 페이지 이동)라 응답을 기다리지 않으면 브라우저가 요청을 취소해
// 서버 세션이 폐기되지 않을 수 있다(2026-08-05, Gemini 코드 리뷰에서 발견). 응답을 기다린
// 뒤(성공이든 실패든) 이동한다 — best-effort 정책 자체는 유지, 순서만 보정.
const LOGOUT_REDIRECT_TIMEOUT_MS = 2_000;

@Injectable({ providedIn: 'root' })
export class LogoutService {
  private readonly api = inject(ApiService);
  private readonly auth = inject(AuthService);

  logout(): void {
    let redirected = false;
    const redirect = () => {
      if (redirected) return;
      redirected = true;
      window.location.href = environment.schoolbellEWebLoginUrl;
    };
    this.auth.clearSession();
    // 응답이 지연/행(hang)되어도 화면이 무한정 멈춰 있지 않도록 상한을 둔다
    // (2026-08-05, Gemini 코드 리뷰에서 발견).
    const timeoutId = setTimeout(redirect, LOGOUT_REDIRECT_TIMEOUT_MS);
    this.api.logout().subscribe({
      next: () => {
        clearTimeout(timeoutId);
        redirect();
      },
      error: () => {
        clearTimeout(timeoutId);
        redirect();
      },
    });
  }
}
